<div class="game-button">
    {{"#"+game?.gameNumber}}
</div>